const FORWARD_STOCKED_LABELS = {
    ALLOCATED: 'Allocated',
    UNALLOCATED: 'Unallocated',
};

export const forwardStockedStatusLabel = (status) => FORWARD_STOCKED_LABELS[status] || 'N/A';
